import { Container, Row, Col } from "react-bootstrap";
import {
  FaLinkedin,
  FaRegEnvelopeOpen,
  FaWhatsappSquare,
  FaGithubSquare,
} from "react-icons/fa";
import logo from "../assets/img/logo.svg";

export const Footer = () => {
  return (
    <footer className="footer">
      <Container>
        <Row className="align-items-center">
          <Col size={12} sm={6}>
            <img src={logo} alt="Logo" />
          </Col>
          <Col size={12} sm={6} className="text-center text-sm-end">
            <div className="social-icon">
              <a href="https://www.linkedin.com/in/muhammad-immad-7b4553207/">
                {" "}
                <FaLinkedin />{" "}
              </a>
              <a href="https://mail.google.com/mail/u/0/#inbox?compose=CllgCJqTgHnFmBsFwMCtzBbVWdsFbJzQZhWVlRHnTSHtvvKVfqtKMfJFzNjsjJdKqxDvGZRVFGB">
                {" "}
                <FaRegEnvelopeOpen />{" "}
              </a>
              <a href="https://wa.me/03363510768">
                {" "}
                <FaWhatsappSquare />{" "}
              </a>
              <a href="https://github.com/itsimmad">
                {" "}
                <FaGithubSquare />{" "}
              </a>
            </div>
            <p>Copyright 2023. All Rights Reserved</p>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};
